"use client";
import { useState, useEffect } from "react";
import { SpandaProClassic } from "./SpandaProClassic";
import { SpandaProPediatric } from "./SpandaProPed";
import { SpandaProVeterinary } from "./SpandaProVet";

const Spandapro = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [selectedModel, setSelectedModel] = useState("classic");
  const [isMobile, setIsMobile] = useState(false);

  const handleButtonClick = (model) => {
    setSelectedModel(model);
  };

  const renderModelComponent = () => {
    switch (selectedModel) {
      case "classic":
        return (
          <SpandaProClassic
            scrollPosition={scrollPosition}
            isMobile={isMobile}
          />
        );
      case "pediatric":
        return (
          <SpandaProPediatric
            scrollPosition={scrollPosition}
            isMobile={isMobile}
          />
        );
      case "veterinary":
        return (
          <SpandaProVeterinary
            scrollPosition={scrollPosition}
            isMobile={isMobile}
          />
        );
      default:
        return null;
    }
  };

  const handleScroll = () => {
    setScrollPosition(window.scrollY || window.pageYOffset);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    // Initialize the isMobile state
    handleResize();

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Clean up event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <section id="Promises" className="relative items-center justify-center">
        <div>
          <h2 className="mb-5 text-center text-2xl font-semibold leading-tight text-black dark:text-white sm:text-4xl sm:leading-tight">
            {/* Spanda DAT */}
          </h2>
        </div>
        <br />
        {renderModelComponent()}
        {/* <div
          className="absolute right-4 top-4 flex flex-col items-end"
          style={{ paddingTop: 10 }}
        >
          <button
            className="mb-2 transform rounded-md bg-blue-800 p-2 text-white transition-transform duration-300 hover:scale-110"
            style={{
              width: isMobile ? "120px" : "200px",
              height: isMobile ? "30px" : "40px",
              fontSize: isMobile ? "12px" : "16px",
              backgroundColor:
                selectedModel === "classic" ? "#0ea5e9" : "#1E40AF",
            }}
            onClick={() => handleButtonClick("classic")}
          >
            Classic
          </button>
          <button
            className="mb-2 transform rounded-md bg-blue-800 p-2 text-white transition-transform duration-300 hover:scale-110"
            style={{
              width: isMobile ? "120px" : "200px",
              height: isMobile ? "30px" : "40px",
              fontSize: isMobile ? "12px" : "16px",
              backgroundColor:
                selectedModel === "veterinary" ? "#0ea5e9" : "#1E40AF",
            }}
            onClick={() => handleButtonClick("veterinary")}
          >
            Veterinary
          </button>
          <button
            className="mb-2 transform rounded-md bg-blue-800 p-2 text-white transition-transform duration-300 hover:scale-110"
            style={{
              width: isMobile ? "120px" : "200px",
              height: isMobile ? "30px" : "40px",
              fontSize: isMobile ? "12px" : "16px",
              backgroundColor:
                selectedModel === "pediatric" ? "#0ea5e9" : "#1E40AF",
            }}
            onClick={() => handleButtonClick("pediatric")}
          >
            Pediatric
          </button>
        </div> */}
      </section>
    </>
  );
};

export default Spandapro;
